// Maximum number of distinct identifiers the backend processes for a multi-value search.
export const SEARCH_IDENTIFIERS_CAP = 500

export interface ParsedSearchIdentifiers {
  // Distinct identifiers, capped at SEARCH_IDENTIFIERS_CAP, in first-seen order.
  identifiers: string[];
  // Number of distinct identifiers before the cap is applied.
  distinctCount: number;
  // True when more than SEARCH_IDENTIFIERS_CAP distinct identifiers were pasted.
  truncated: boolean;
}

/**
 * Parse a raw search string the same way the backend does: split on any run of
 * whitespace or commas (spaces, tabs, newlines incl. \r\n), trim, drop empties,
 * de-duplicate, and cap the distinct set at SEARCH_IDENTIFIERS_CAP.
 *
 * Kept dependency-free so it can be unit-tested without importing components.
 */
export const parseSearchIdentifiers = (raw: string | null | undefined): ParsedSearchIdentifiers => {
  const seen = new Set<string>()
  const identifiers: string[] = []

  if (raw) {
    for (const token of raw.split(/[\s,]+/)) {
      const trimmed = token.trim()
      if (!trimmed || seen.has(trimmed)) continue
      seen.add(trimmed)
      if (identifiers.length < SEARCH_IDENTIFIERS_CAP) identifiers.push(trimmed)
    }
  }

  return {
    identifiers,
    distinctCount: seen.size,
    truncated: seen.size > SEARCH_IDENTIFIERS_CAP
  }
}
